import { workspaceConnectionsApi } from './workspace-connections.feature';
import type { SheetColumnsResponse } from '@/containers/playbooks/custom-builder/config/sheet-trigger.util';

/** Uses the existing member-authenticated workspace API and org cache scope. */
export const sheetSourceApi = workspaceConnectionsApi.injectEndpoints({
  endpoints: (builder) => ({
    getSheetTriggerColumns: builder.query<
      SheetColumnsResponse,
      { organizationId: string; spreadsheetId: string; gid?: number | null }
    >({
      query: ({ organizationId, spreadsheetId, gid }) => ({
        url: `/integrations/workspace/google_sheets/sheets/${encodeURIComponent(spreadsheetId)}/columns`,
        params: gid == null ? undefined : { gid },
        headers: { 'X-Cleanlist-Expected-Org': organizationId },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useLazyGetSheetTriggerColumnsQuery } = sheetSourceApi;
